const logLevel = process.env.VUE_APP_LOG_LEVEL;

export default function() {
	if (logLevel === 'Debug') {
		console.log(...arguments);
	}
}
